import { toAbsoluteUrl } from "../../_metronic/_helpers/AssetsHelpers";
import config from "../../setting";
import { PositionElement } from "../tripDetails/components/PositionElement";
import ReactDOMServer from "react-dom/server";
import { Box } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { timeline } from "../tripDetails/style";
import moment from "moment";
import { createRoot } from "react-dom/client";
import { t } from "i18next";
import loadIcon from "../../assets/images/icons/loadCount.svg";
import hook from "../../assets/images/icons/hook.svg";
import unhook from "../../assets/images/icons/unhook.svg";
import pickup from "../../assets/images/icons/pickUp.svg";
import dropoff from "../../assets/images/icons/dropOff.svg";
import delivery from "../../assets/images/icons/delivery.svg";
import { formatDate } from "../../utils/DateUtils";


// Dichiarazione globale per evitare errori di tipo
declare const H: any;

// Variabile globale per gestire lo stato del popup attivo
let activeBubble: any = null;
interface Position {
    latitude: number;
    longitude: number;
    label?: string;
}

export const DetailsMapService = {
        createMap: (
            containerId: string,
            center: { lat: number; lng: number },
            zoom: number = 5,
            mapTileType: string = "omv.map.logistics" // esempio tile vettoriale HERE
        ): { map: any; behavior: any; ui: any; platform: any } | null => {
            if (!H) {
                console.error("HERE Maps library is not loaded.");
                return null;
            }
    
            const platform = new H.service.Platform({
                apikey: config.HMap_AppKey,
            });
    
            const mapContainer = document.getElementById(containerId) as HTMLElement;
            if (!mapContainer) {
                console.error("Map container not found");
                return null;
            }
    
            const baseLayer = DetailsMapService.getCustomTileLayer(platform, mapTileType);
            if (!baseLayer) {
                console.error("Failed to create tile base layer.");
                return null;
            }
    
            // Validazione centro mappa
            const validCenter = center && typeof center.lat === "number" && typeof center.lng === "number"
                ? center
                : { lat: 0, lng: 0 };
    
            const zoomMap = validCenter.lat === 0 && validCenter.lng === 0 ? 3 : zoom;
    
            const map = new H.Map(mapContainer, baseLayer, {
                center: validCenter,
                zoom: zoomMap,
                pixelRatio: window.devicePixelRatio || 1,
            });
    
            const behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
            const defaultLayers = platform.createDefaultLayers();
            const ui = H.ui.UI.createDefault(map, defaultLayers);
    
            return { map, behavior, ui, platform };
                },

    getCustomTileLayer: (platform: any, mapTileType: string): any => {
        const hd = window.devicePixelRatio > 1;
        const tileSize = hd ? 512 : 256;

        const provider = new H.map.provider.ImageTileProvider({
            min: 0,
            max: 20,
            getURL: (x: number, y: number, z: number) =>
                `https://maps.hereapi.com/v3/base/mc/${z}/${x}/${y}/png?apikey=${config.HMap_AppKey}&style=${mapTileType}`,
        });
        return new H.map.layer.TileLayer(provider);
    },

    renderActualViewRoute: (map: any, coordArr: { lat: number; lng: number }[]) => {
        const lineString = new H.geo.LineString();
        coordArr.forEach((coord) => lineString.pushPoint({ lat: coord.lat, lng: coord.lng }));

        const polyline = new H.map.Polyline(lineString, {
            style: {
                strokeColor: "#cb4c4c",
                fillColor: '#cb4c4c',
                lineWidth: 4,
                lineTailCap: "arrow-tail",
                lineHeadCap: "arrow-head",
                lineDash: [2],
            },
        });

        map.addObject(polyline);
        return polyline;
    },

    startClustering: (data: any[], hMap: any, ui: any) => {
        const markers: { clusterMarkers: any[]; noiseMarkers: any[] } = {
            clusterMarkers: [],
            noiseMarkers: [],
        };

        // Filtra e valida i dati
        const validData = data.filter(
            (item: { latitude: number; longitude: number }) =>
                typeof item.latitude === "number" &&
                typeof item.longitude === "number" &&
                item.latitude >= -90 &&
                item.latitude <= 90 &&
                item.longitude >= -180 &&
                item.longitude <= 180
        );

        const dataPoints = validData.map(
            (item) => new H.clustering.DataPoint(item.latitude, item.longitude)
        );


        // Configurazione del clustering
        const clusteredDataProvider = new H.clustering.Provider(dataPoints, {
            clusteringOptions: {
                eps: 32,
                minWeight: 2,
            },
            theme: {
                getClusterPresentation: function (cluster: any) {
                    const div = document.createElement("div");
                    div.style.cursor = 'pointer'
                    div.className = "z-[99999] w-[25px] h-[25px] my-[-5px] rounded-[15px] border-2 border-[#CF0A2C] bg-white text-center text-[#CF0A2C]";

                    div.textContent = cluster.getWeight().toString();

                    const clusterMarker = new H.map.DomMarker(cluster.getPosition(), {
                        icon: new H.map.DomIcon(div),
                        min: cluster.getMinZoom(),
                        max: cluster.getMaxZoom(),
                    });

                    clusterMarker.addEventListener('tap', (event: any) => {
                        if (hMap.getZoom() < 20) {
                            hMap.setCenter(cluster.getPosition());
                            hMap.setZoom(hMap.getZoom() + 3);
                        }
                        else {
                            const tolerance = 0.00001;

                            const similarElements = data.filter(item =>
                                Math.abs(Number(item.latitude) - cluster.getPosition().lat) < tolerance &&
                                Math.abs(Number(item.longitude) - cluster.getPosition().lng) < tolerance
                            );

                            if (similarElements.length > 0) {
                                const positionDetections = similarElements.map(el => el.positionDetection);
                                const mergedPositionDetections = positionDetections.flat();
                                const uniquePositionDetections = Array.from(new Set(mergedPositionDetections)); // Rimuovi duplicati

                                similarElements.forEach(el => {
                                    el.positionDetection = uniquePositionDetections;
                                });
                            }
                        }
                    });

                    hMap.addObject(clusterMarker);

                    markers.clusterMarkers.push(clusterMarker);
                    return clusterMarker;
                },
                getNoisePresentation: function (noisePoint: any) {
                    const div = document.createElement("div");
                    div.style.cursor = 'pointer'
                    div.className = "z-[99999] w-[12px] h-[12px] my-[-5px] ml-[-2px] rounded-[10px] border-2 border-[#CF0A2C] bg-white";

                    const noiseMarker = new H.map.DomMarker(noisePoint.getPosition(), {
                        icon: new H.map.DomIcon(div),
                        min: noisePoint.getMinZoom(),
                    });

                    noiseMarker.addEventListener("tap", () => {
                        const pointData = noisePoint.Uc; // Ottiengo le position 

                        if (!pointData || !pointData.lat || !pointData.lng) {
                            console.warn("Invalid data for noisePoint:", pointData);
                            return;
                        }

                        const correspondingData = validData.find(
                            (item) =>
                                Math.abs(Number(item.latitude) - pointData.lat) < 0.00001 &&
                                Math.abs(Number(item.longitude) - pointData.lng) < 0.00001
                        );

                        if (!correspondingData) {
                            console.warn("No matching data found for noisePoint");
                            return;
                        }

                        ui.removeBubble(activeBubble);

                        // Crea un div per montare PositionElement
                        const container = document.createElement("div");

                        const bubble = new H.ui.InfoBubble(
                            { lat: pointData.lat, lng: pointData.lng },
                            { content: container }
                        );

                        activeBubble = bubble

                        ui.addBubble(bubble);

                        const root = createRoot(container);
                        root.render(
                            <PositionElement
                                position={{
                                    lat: correspondingData.latitude,
                                    lng: correspondingData.longitude,
                                    provider: correspondingData.trailerSourceGPSProviderName || "Unknown Provider",
                                    dateTime: [new Date(correspondingData.positionDetectionDateTimeUTC)],
                                }}
                            />
                        );

                        if (ui) {
                            ui.addBubble(bubble);
                        } else {
                            console.error("UI instance is not available.");
                        }
                    });

                    hMap.addObject(noiseMarker);

                    markers.noiseMarkers.push(noiseMarker);

                    return noiseMarker;
                },
            },
        });

        // Aggiungi il clustering alla mappa
        const clusterLayer = new H.map.layer.ObjectLayer(clusteredDataProvider);
        hMap.addLayer(clusterLayer);

        return markers;
    },


    markers: {
        addActualPositionMarker: (map: any, actualPosition: any, ui: any) => {
            const domElement = document.createElement("div");
            const image = document.createElement("img");

            image.src = toAbsoluteUrl("/media/svg/map/actual-position.svg");
            image.style.width = "30px";
            image.style.height = "30px";
            image.style.marginLeft = "-2px";
            image.style.marginTop = "-10px";
            domElement.style.cursor = "pointer";

            const pulsatingCircle = document.createElement("div");
            pulsatingCircle.className = "absolute top-[-12px] left-[-12px] w-12 h-12 bg-[#CF0A2C] bg-opacity-50 rounded-full animate-ping";

            domElement.appendChild(pulsatingCircle);
            domElement.appendChild(image);

            const domIcon = new H.map.DomIcon(domElement);
            const marker = new H.map.DomMarker(
                { lat: actualPosition.latitude, lng: actualPosition.longitude },
                { icon: domIcon, zIndex: 9999 }
            );

            // Crea un div per montare PositionElement
            const container = document.createElement("div");

            // Evento per il popup
            marker.addEventListener("tap", () => {
                const bubble = new H.ui.InfoBubble(
                    { lat: actualPosition.latitude, lng: actualPosition.longitude },
                    { content: container }
                );

                const root = createRoot(container);
                root.render(
                    <PositionElement
                        position={{
                            lat: actualPosition.latitude,
                            lng: actualPosition.longitude,
                            provider: actualPosition.trailerSourceGPSProviderName || "Unknown Provider",
                            dateTime: [new Date(actualPosition.positionDetectionDateTimeUTC)],
                        }}
                    />
                );

                ui.removeBubble(activeBubble);

                activeBubble = bubble

                ui.addBubble(bubble);
            });

            map.addObject(marker);
        },


        addStopMarker: (map: any, position: Position, ui: any, stopData: any) => {
            const { relatedActivities } = stopData;

            const activityIcons: Record<string, string> = {
                DELIVERY: delivery,
                LOAD: loadIcon,
                HOOK: hook,
                UNHOOK: unhook,
                PICKUP: pickup,
                DROPOFF: dropoff,
            };

            // Estrai i tipi di attività da relatedActivities
            const activityTypes = relatedActivities?.map((activity: any) => activity.activityType) || [];
            const relatedActivity = activityTypes.find((activity: string) => activityIcons[activity]);



            const iconElement = relatedActivity ? (
                <Box
                    style={{
                        borderRadius: "50%",
                        backgroundColor: "#CF0A2C",
                        width: 24,
                        height: 24,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <img className="w-5 h-5" src={activityIcons[relatedActivity]} alt={`${relatedActivity.toLowerCase()} icon`} />
                </Box>
            ) : (
                <Box
                    style={{
                        borderRadius: "50%",
                        backgroundColor: "#CF0A2C",
                        width: 24,
                        height: 24,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                />
            );

            // Crea il contenitore DOM per il marker
            const markerContainer = document.createElement("div");
            markerContainer.innerHTML = ReactDOMServer.renderToString(iconElement);
            markerContainer.style.cursor = "pointer";

            // Crea il marker DOM con HERE Maps
            const domIcon = new H.map.DomIcon(markerContainer);
            const marker = new H.map.DomMarker(
                { lat: position.latitude, lng: position.longitude },
                { icon: domIcon }
            );

            // Popup per i dettagli del punto
            const popupContent = ReactDOMServer.renderToString(
                <div className="flex flex-col items-center h-fit w-fit min-w-[330px] px-3">
                    <div className="m-0 flex flex-row flex-nowrap mb-3">
                        <div className="flex-grow">
                            <h1 className="font-bold">{stopData?.invPartyName || "Unknown Party"}</h1>
                            <h3>{stopData?.address || "Unknown Address"}</h3>
                        </div>
                    </div>
                    <div className="m-0 flex flex-row flex-nowrap shrink w-full gap-x-28">
                        {/* Departure Column */}
                        <div className="shrink break-words w-1/2">
                            {/* Expected Departure */}
                            <div className="mb-2">
                                <h2>{capitalizeFirstLetter(t("screens.trips.datesCard.expectedDeparture"))}</h2>
                                <h6>{stopData.expectedDeparture ? formatDate(stopData.expectedDeparture) : '-'}</h6>
                            </div>
                            {/* Expected Arrival */}
                            <div>
                                <h2>{capitalizeFirstLetter(t("screens.trips.datesCard.expectedArrival"))}</h2>
                                <h6>{stopData.expectedArrival ? formatDate(stopData.expectedArrival) : '-'}</h6>
                            </div>
                        </div>
                        {/* Arrival Column */}
                        <div className="shrink break-words w-1/2">
                            {/* Actual Departure */}
                            <div className="mb-2">
                                <h2>{capitalizeFirstLetter(t("screens.trips.datesCard.actualDeparture"))}</h2>
                                <h6>{stopData.actualDeparture ? formatDate(stopData.actualDeparture) : '-'}</h6>
                            </div>
                            {/* Actual Arrival */}
                            <div>
                                <h2>{capitalizeFirstLetter(t("screens.trips.datesCard.actualArrival"))}</h2>
                                <h6>{stopData.actualArrival ? formatDate(stopData.actualArrival) : '-'}</h6>
                            </div>
                        </div>
                    </div>
                </div>
            );

            marker.addEventListener("tap", () => {
                const bubble = new H.ui.InfoBubble(
                    { lat: position.latitude, lng: position.longitude },
                    { content: popupContent }
                );

                ui.removeBubble(activeBubble);

                activeBubble = bubble;

                ui.addBubble(bubble);
            });

            map.addObject(marker);
        }



    },
};

function capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}


